<template>
  <div class="payment-result" :class="{'payment-result_resize': fixedBottom}">
    <div class="main_wraper" :class="{'main_wraper_resize_fixed': fixedBottom}">
      <header :class="{'header-fixed': !fixedBottom}">
        <p>{{ $t('payResult.result') }}</p>
        <p v-if="payMentstatus === 2" @click="openVoucher">{{ $t('payResult.voucher') }}</p>
      </header>
      <section :class="{'section-top_fixed': !fixedBottom}">
        <div class="payment-status">
          <div class="status-image">
            <img :src="img">
          </div>
          <p class="status-description" v-if="payMentstatus === 2">{{$t('payResult.success')}}</p>
          <p class="status-description" v-if="payMentstatus === 4">{{$t('payResult.failure')}}</p>
          <p class="status-description" v-if="payMentstatus !== 2 && payMentstatus !== 4">{{$t('payResult.processing')}}</p>
        </div>

        <div class="product-message">
          <div>
            <p>{{ $t('payResult.mchtName')}}</p>
            <p>{{ shopname }}</p>
          </div>
          <div>
            <p>{{ $t('payResult.mchtOrderId')}}</p>
            <p>{{ order_id }}</p>
          </div>
          <div>
            <p>{{ $t('payResult.payOrderId')}}</p>
            <p>{{ syssn }}</p>
          </div>
          <div>
            <p>{{ $t('payResult.totalPrice')}}</p>
            <p>{{currencyList[link_currency]}}{{ link_amt }}</p>
          </div>
        </div>
        <!-- 成功状态特有功能 -->
        <div class="customer-message" v-if="payMentstatus === 2">
          <div class="logistics-mode customer-message_common">
            <p>{{ $t('payResult.logisticsMode.title') }}</p>
            <p>{{ deliveryTypeList[delivery_type] }}</p>
          </div>
          <div class="address">
            <p v-if="delivery_type === 1">{{ $t('payResult.mchtAddress') }}</p>
            <p v-if="delivery_type === 1">{{ sender_address.detail }}</p>
            <p v-if="delivery_type === 2">{{ $t('payResult.address') }}</p>
            <p v-if="delivery_type === 2">{{ receiver_address.detail}}</p>
          </div>
          <div class="mailbox customer-message_common" v-if="delivery_type === 1">
            <p>{{ $t('payResult.mchtMailbox') }}</p>
            <p>{{ sender_address.email }}</p>
          </div>
          <div class="telephone customer-message_common" v-if="delivery_type === 1">
            <p>{{ $t('payResult.mchtTelephone') }}</p>
            <p>{{ sender_address.telephone }}</p>
          </div>
          <div class="delevery-time customer-message_common" v-if="delivery_type === 2 && delivery_time">
            <p>{{ $t('payBefore.expectedDeliveryTime') }}</p>
            <p>{{ delivery_time }}</p>
          </div>
        </div>

        <div class="accept-message" v-if="payMentstatus === 2">
          <img :src="selectedImage" @click="changeSelectStatus">
          <p>{{ $t('payResult.accept') }}</p>
        </div>
        <!-- 成功状态特有功能 -->
        <div class="query-status" :class="{'appisFixed_button': !inputStatus}">
          <button v-if="payMentstatus === 2" @click="confirm" :disabled="confirmStatus">{{ $t('payResult.confirm') }}</button>
          <button v-if="payMentstatus === 4" @click="payAgain">{{ $t('payResult.payAgain') }}</button>
          <button v-if="payMentstatus !== 2 && payMentstatus !== 4" @click="getPayDoneMsg">{{ $t('payResult.queryStatus') }}</button>
        </div>

        <div class="bottom_msg" v-if="!inputStatus">
          <span>Solution powered by </span>
          <img src="../../assets/bottom_brand logo.svg" alt="">
        </div>
      </section>
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      :show-close="false">
      <div slot="title" class="dialogTitle">
        <img :src="defaultImg" alt="">
        <p>{{ shopname }}</p>
      </div>
      <div class="dialogContent">
        <p class="dialogContent_voucher">{{ $t('payResult.paymentVoucher') }}</p>
        <div class="voucherStatus">
          <p>{{ $t('payResult.status') }}</p>
          <p>{{ payMentstatusList[payMentstatus]}}</p>
        </div>
        <div class="merchant-id">
          <p>{{ $t('payResult.mchtOrderId') }}</p>
          <p>{{ order_id }}</p>
        </div>
        <div class="payment-id">
          <p>{{ $t('payResult.payOrderId') }}</p>
          <p>{{ syssn }}</p>
        </div>
        <div class="paymentTime">
          <p>{{ $t('payResult.payTime') }}</p>
          <p>{{ payment_time }}</p>
        </div>
        <div class="total_price">
          <p>{{ $t('payResult.totalPrice') }}</p>
          <p>{{currencyList[link_currency]}}{{ link_amt }}</p>
        </div>
        <div class="customerName">
          <p>{{ $t('payResult.customerName') }}</p>
          <p>{{ name }}</p>
        </div>
        <div class="customerTel">
          <p>{{ $t('payResult.CustomerTelephone') }}</p>
          <p>{{ mobile }}</p>
        </div>
      </div>

      <div class="dialog-footer">
        <span>Solution powered by</span>
        <img src="../../assets/voucher_qf.svg" alt="">
      </div>

      <div class="footer" v-if="isNotWx">
        <img src="../../assets/btn_save.svg" alt="" @click="dowmloadVouchers">
        <p v-if="inputStatus" class="savePC">{{ $t('payResult.save') }}</p>
        <p v-if="!inputStatus" class="saveMobile">{{ $t('payResult.saveTo') }}</p>
      </div>
    </el-dialog>

    <div class="bottom_msg_pc" v-if="inputStatus && !fixedBottom">
      <span>Solution powered by</span>
      <img src="../../assets/c_qfpay_pc.svg" alt="">
    </div>

    <div class="bottom_msg_pc_fixed" v-if="inputStatus && fixedBottom">
      <span>Solution powered by</span>
      <img src="../../assets/c_qfpay_pc.svg" alt="">
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
import { paramStringify } from '../../utils/sort'
import { currencyMap } from '../../map/currencyMap'
export default {
  name: 'paymentResult',
  data () {
    return {
      shopname: '',
      order_id: '',
      syssn: '',
      link_amt: '',
      sender_address: {},
      receiver_address: {},
      payment_time: '',
      link_currency: '',
      name: '',
      mobile: '',
      delivery_type: '',
      delivery_time: '',
      inputStatus: false, // 判断pc or mobile
      fixedBottom: true, // 判断浏览器高度是否超过显示屏幕高度
      payMentstatus: '', // 根据请求返回不同状态 2为成功，4为失败
      img: require('../../assets/processing.svg'),
      selected: false,
      selectedImage: '',
      dialogVisible: false,
      defaultImg: require('../../assets/mchnt_logo.svg'),
      agree_pact: '',
      confirmStatus: false,
      isNotWx: false,
      payMentstatusList: {
        2: this.$t('payResult.success'),
        4: this.$t('payResult.failure'),
        1: this.$t('payResult.processing'),
        3: this.$t('payResult.processing'),
        5: this.$t('payResult.processing'),
        6: this.$t('payResult.processing'),
        7: this.$t('payResult.processing')
      },
      deliveryTypeList: {
        1: this.$t('payResult.logisticsMode.mode4'),
        2: this.$t('payResult.logisticsMode.mode3')
      },
      currencyList: currencyMap
    }
  },
  created () {
    this.getClientWidth()
    this.getPayDoneMsg()
    this.getInformationIsWx()
  },
  mounted () {
    this.getFixedBottom()
  },
  methods: {
    getClientWidth () {
      if (document.body.clientWidth > 900) {
        this.inputStatus = true
      } else {
        this.inputStatus = false
      }
    },
    getPayDoneMsg () {
      const params = {
        order_id: String(this.$route.query.order_id),
        format: 'cors'
      }
      // axios.post('http://172.100.108.106:8084/remotepay/pay/pay_done', qs.stringify(params))
      axios.post(`${location.protocol}//${location.hostname}/remotepay/pay/pay_done`, qs.stringify(params))
        .then(res => {
          const data = res.data
          if (data.respcd === '0000') {
            this.payMentstatus = data.data.status
            this.shopname = data.data.shopname
            this.order_id = data.data.order_id
            this.syssn = data.data.syssn
            this.sender_address = data.data.sender_address
            this.receiver_address = data.data.receiver_address
            this.selected = data.data.privacy
            this.delivery_time = data.data.delivery_time
            this.payment_time = data.data.payment_time
            this.link_currency = data.data.link_currency
            this.link_amt = data.data.link_amt
            this.name = data.data.name
            this.mobile = data.data.mobile
            this.customer_id = data.data.customer_id
            this.delivery_type = data.data.delivery_type
            this.agree_pact = data.data.agree_pact
            if (this.selected === 2) {
              this.selected = true
              this.selectedImage = require('../../assets/selected.png')
            } else if (this.selected === 1) {
              this.selected = false
              this.selectedImage = require('../../assets/unselected.png')
            }
            if (this.payMentstatus === 2) {
              this.img = require('../../assets/success.svg')
            } else if (this.payMentstatus === 4) {
              this.img = require('../../assets/failure.svg')
            } else {
              this.img = require('../../assets/processing.svg')
            }
          } else {
            this.$message.error(data.respmsg)
          }
        })
    },
    payAgain () {
      const params = {
        order_id: String(this.order_id),
        return_url: `${location.protocol}//${location.hostname}/remotepay/pay/pay_result`,
        failed_url: `${location.protocol}//${location.hostname}/remotepay/pay/pay_result`,
        format: 'cors'
      }
      axios.post(`${location.protocol}//${location.hostname}/remotepay/pay/do_order`, qs.stringify(params))
      // axios.post('http://172.100.113.34:6510/remotepay/pay/redo_order', qs.stringify(params))
        .then(res => {
          const data = res.data
          if (data.respcd === '0000') {
            this.order_id = data.data.order_id
            const pamData = data.data.pay
            const host = location.hostname.replace('item', 'openapi')
            window.location.href = `${location.protocol}//${host}/checkstand/#/?${paramStringify(pamData, true)}`
            // window.location.href = `https://openapi-int.qfapi.com/checkstand/#/?${paramStringify(pamData, true)}`
            // window.location.href = `https://openapi.qa.qfpay.net/checkstand/#/?${paramStringify(pamData, true)}`
            // window.location.href = `https://openapi-hk.qfapi.com/checkstand/#/?${paramStringify(pamData, true)}`
          } else {
            this.$message.error(data.respmsg)
          }
        })
    },
    confirm () {
      let privacy
      if (this.selected) {
        privacy = 2
      } else {
        privacy = 1
      }
      const params = {
        customer_id: this.customer_id,
        privacy: privacy,
        format: 'cors'
      }
      // axios.post('http://172.100.113.34:6510/remotepay/customer/edit', qs.stringify(params))
      axios.post(`${location.protocol}//${location.hostname}/remotepay/customer/edit`, qs.stringify(params))
        .then(res => {
          const data = res.data
          if (data.respcd === '0000') {
            this.confirmStatus = true
            this.closeWindow()
          } else {
            this.$message.error(data.respmsg)
          }
        })
    },
    closeWindow () {
      const userAgent = navigator.userAgent
      if (userAgent.indexOf('Firefox') !== -1 || userAgent.indexOf('Chrome') !== -1) {
        window.location.href = 'about:blank'
        window.close()
      } else {
        window.opener = null
        window.open('', '_self')
        window.close()
      }
    },
    getFixedBottom () {
      if (document.documentElement.scrollHeight <= window.innerHeight) {
        this.fixedBottom = true
      } else {
        this.fixedBottom = false
      }
    },
    changeSelectStatus () {
      this.selected = !this.selected
      if (this.selected) {
        this.selectedImage = require('../../assets/selected.png')
      } else {
        this.selectedImage = require('../../assets/unselected.png')
      }
    },
    openVoucher () {
      this.dialogVisible = true
    },
    dowmloadVouchers () {
      window.location.href = `${location.protocol}//${location.hostname}/remotepay/pay/pay_voucher?order_id=${this.$route.query.order_id}&&format=cors`
    },
    getInformationIsWx () {
      const ua = navigator.userAgent
      if ((/MicroMessenger/i).test(ua)) {
        this.isNotWx = false
      } else {
        this.isNotWx = true
      }
    }
  }
}
</script>

<style lang="scss">
  @media only screen and (max-width: 900px) {
    .payment-result {
      background-color: #FFFFFF;
      background-size: contain;
      width: 100%;
      .main_wraper {
        header {
          height: 44.69px;
          width: 100%;
          background-color: #FFFFFF;
          border-bottom: 1px solid #EBEBEB;
          box-sizing: border-box;
          p:nth-child(1) {
            text-align: center;
            padding-top: 11px;
            font-size: 17px;
            color: #000000;
            height: 24px;
            line-height: 24px;
          }
          p:nth-child(2) {
            position: absolute;
            top: 13px;
            right: 15px;
            font-size: 15px;
            height: 21px;
            line-height: 21px;
            color: #000000;
          }
        }
        section {
          padding-left: 15px;
          padding-right: 15px;
          margin-top: 21px;
          padding-bottom: 113px;
          .payment-status {
            height: 96px;
            width: 96px;
            margin: 0 auto;
            text-align: center;
            .status-image {
              img {
                width: 60px;
                height: 60px;
              }
            }
          }
          .product-message {
            margin-top: 50px;
            div {
              height: 15px;
              font-size: 15px;
              line-height: 15px;
              margin-bottom: 15px;
              p:nth-child(1) {
                float: left;
                color: #8A8C92;
              }
              p:nth-child(2) {
                float: right;
                color: #000000;
              }
            }
            div:nth-last-child(1) {
              margin-bottom: 0;
              padding-bottom: 15px;
              border-bottom: 1px dashed #A7A9AE;
            }
          }
          .customer-message {
            margin-top: 14px;
            .customer-message_common {
              height: 15px;
              line-height: 15px;
              font-size: 15px;
              margin-bottom: 15px;
              p:nth-child(1) {
                color: #8A8C92;
                float: left;
              }
              p:nth-child(2) {
                color: #000000;
                float: right;
              }
            }
            .address {
              min-height: 108px;
              margin-bottom: 22px;
              p:nth-child(1) {
                height: 15px;
                line-height: 15px;
                font-size: 15px;
                margin-bottom: 15px;
                color: #8A8C92;
              }
              p:nth-child(2) {
                min-height: 78px;
                width: 100%;
                background-color: #F7F7F7;
                border-radius:3px;
                padding: 15px;
                box-sizing: border-box;
                color: #000000;
                font-size: 15px;
                line-height: 24px;
                word-break: break-all;
              }
            }
            .mailbox, .telephone {
              height: 20px;
              height: 20px;
              line-height: 20px;
            }
            .telephone {
              margin-bottom: 0;
              padding-bottom: 16px;
              border-bottom: 1px dashed #A7A9AE;
            }
            div:nth-last-child(1) {
              margin-bottom: 0;
              padding-bottom: 16px;
              border-bottom: 1px dashed #A7A9AE;
            }
          }
          .accept-message {
            height: 36px;
            margin-top: 14px;
            width: 100%;
            display: flex;
            img {
              width: 15px;
              height: 15px;
              vertical-align: middle;
              margin-right: 7px;
              margin-top: 2px;
            }
            p {
              height: 36px;
              font-size: 13px;
              line-height: 18px;
              color: #000000;
            }
          }
          .query-status {
            margin-top: 25px;
            height: 50px;
            border: none;
            border-radius:8px;
            button {
              border: none;
              color: #FFFFFF;
              font-size: 17px;
              line-height: 50px;
              background-color: #FF8100;
              border-radius:8px;
              padding: 0;
              width: 100%;
            }
          }
          .bottom_msg {
            position: fixed;
            left: 0;
            bottom: 0;
            padding-top: 10px;
            padding-bottom: 15px;
            width: 100%;
            text-align: center;
            font-size: 13px;
            height: 13px;
            line-height: 13px;
            background-color: #FFFFFF;
            img {
              vertical-align: middle;
              width: 48.9px;
              height: 12.87px;
            }
          }
        }
        // 移动端吸底按钮判断
        .appisFixed_button {
          width: 100%;
          box-sizing: border-box;
          padding-left: 15px;
          padding-right: 15px;
          position: fixed;
          bottom: 38px;
          left: 0;
          background-color: #FFFFFF;
        }
        // 屏幕出现滚动条，头部固定，屏幕未出现滚动条，头部正常显示
        .header-fixed {
          position: fixed;
          top: 0;
          left: 0;
        }
        .section-top_fixed {
          margin-top: 65.69px;
        }
      }
      .el-dialog__wrapper {
        .el-dialog {
          background: none;
          border: none;
          box-shadow: none;
          width: 325px;
          background:#FFFFFF;
          box-shadow:0px 1px 4px 0px rgba(0,0,0,0.09);
          border-radius:8px;
          .el-dialog__header {
            padding: 15px;
            height: 55px;
            box-sizing: border-box;
            background-color: #FBFBFB;
            border-radius:8px;
            .dialogTitle {
              display: flex;
              align-items: center;
              img {
                height: 25px;
                width: 25px;
                border-radius: 25px;
                border: 1px solid #E5E5E5;
                vertical-align: middle;
                margin-right: 10px;
              }
              p {
                font-size: 15px;
                line-height: 17px;
                font-weight: 600;
                height: 17px;
              }
            }
          }
          .el-dialog__body {
            padding: 0;
            border-radius:8px;
            .dialogContent {
              padding: 0 15px;
              margin-top: 25px;
              .dialogContent_voucher {
                height: 18px;
                font-weight: 600;
                line-height: 18px;
                font-size: 20px;
                text-align: center;
                color: #000000;
                margin-bottom: 35px;
              }
              div {
                height: 15px;
                line-height: 15px;
                font-size: 14px;
                margin-bottom: 20px;
                p:nth-child(1) {
                  float: left;
                  color: #8A8C92;
                }
                p:nth-child(2) {
                  float: right;
                  color: #000000;
                  font-weight: 500;
                }
              }
              .payment-id, .merchant-id {
                height: auto;
                display: flex;
                justify-content: space-between;
                line-height: 15px;
                p:nth-child(1) {
                  white-space: nowrap;
                }
                p:nth-child(2) {
                  text-align: right;
                }
              }
              .total_price {
                padding-bottom: 20px;
                border-bottom: 1px dashed #A7A9AE;
              }
            }
            .dialog-footer {
              background-color: #FBFBFB;
              margin-top: 5px;
              height: 46px;
              line-height: 46px;
              font-size: 13px;
              color: #D8D8D8;
              border-radius:8px;
              span {
                margin-right: 6px;
                margin-left: 53px;
              }
              img {
                vertical-align: middle;
                height: 12.87px;
                width: 48.9px;
              }
            }
            .footer {
              width: 100%;
              position: absolute;
              text-align: center;
              bottom: -111px;
              img {
                height: 56px;
                width: 56px;
                cursor: pointer;
              }
              .saveMobile {
                width: 100%;
                font-size: 15px;
                height: 15px;
                line-height: 15px;
                margin-top: 15px;
                color: #FFFFFF;
                text-align: center;
              }
            }
          }
        }
      }
    }
  }
  @media only screen and (min-width: 900px) {
    .payment-result {
      background: url('../../assets/bg_pc.png') no-repeat;
      background-color: #F7F7F7;
      background-size: contain;
      .main_wraper {
        width: 900px;
        margin: 0 auto;
        margin-bottom: 39px;
        header {
          height: 44px;
          padding-top: 47px;
          margin-bottom: 25px;
          p:nth-child(1) {
            float: left;
            height: 32px;
            font-size: 32px;
            line-height: 32px;
            font-weight: 600;
            color: #FFFFFF;
          }
          p:nth-child(2) {
            margin-top: 19px;
            float: right;
            height: 25px;
            font-size: 18px;
            line-height: 25px;
            text-align: right;
            color: #FFFFFF;
            &:hover {
              cursor: pointer;
            }
          }
        }
        section {
          background-color: #FFFFFF;
          box-shadow:0px 7px 20px 0px rgba(0,0,0,0.05);
          border-radius:10px;
          .payment-status {
            height: 116px;
            width: 116px;
            padding-top: 67px;
            margin: 0 auto;
            text-align: center;
            .status-image {
              width: 116px;
              height: 116px;
              display: flex;
              justify-content: center;
              align-items: center;
              img {
                vertical-align: middle;
                height: 116px;
                width: 116px;
              }
            }
            .status-description {
              color: #000000;
              height: 20px;
              width: 100%;
              line-height: 20px;
              font-size: 20px;
              font-weight: 500;
              margin-top: -9px;
            }
          }
          .product-message {
            margin-top: 98px;
            padding-left: 30px;
            padding-right: 30px;
            box-sizing: border-box;
            div {
              height: 15px;
              font-size: 15px;
              line-height: 15px;
              margin-bottom: 20px;
              p:nth-child(1) {
                float: left;
                color: #8A8C92;
              }
              p:nth-child(2) {
                float: right;
                color: #000000;
              }
            }
            div:nth-last-child(1) {
              margin-bottom: 0;
              padding-bottom: 20px;
              border-bottom: 1px dashed #A7A9AE;
            }
          }
          .customer-message {
            margin-top: 20px;
            padding-left: 30px;
            padding-right: 30px;
            box-sizing: border-box;
            .customer-message_common {
              height: 15px;
              line-height: 15px;
              font-size: 16px;
              margin-bottom: 20px;
              p:nth-child(1) {
                float: left;
                color: #8A8C92;
              }
              p:nth-child(2) {
                float: right;
                color: #000000;
              }
            }
            .address {
              min-height: 15px;
              display: flex;
              margin-bottom: 20px;
              justify-content: space-between;
              p:nth-child(1) {
                color: #8A8C92;
                font-size: 16px;
              }
              p:nth-child(2) {
                width: 570px;
                text-align: right;
                line-height: 20px;
                word-break: break-all;
                font-size: 16px;
              }
            }
            .telephone {
              margin-bottom: 0;
              padding-bottom: 20px;
              border-bottom: 1px dashed #A7A9AE;
            }
            div:nth-last-child(1) {
              margin-bottom: 0;
              padding-bottom: 16px;
              border-bottom: 1px dashed #A7A9AE;
            }
          }
          .accept-message {
            height: 16px;
            margin-top: 30px;
            margin-left: 30px;
            img {
              width: 16px;
              height: 16px;
              vertical-align: middle;
              float: left;
              margin-right: 8px;
            }
            p {
              height: 16px;
              font-size: 16px;
              line-height: 16px;
              color: #000000;
              float: left;
            }
          }
          .query-status {
            margin: 0 auto;
            margin-top: 40px;
            padding-bottom: 40px;
            height: 50px;
            width: 250px;
            button {
              width: 250px;
              color: #FFFFFF;
              line-height: 50px;
              border: none;
              background-color: #FF8100;
              border-radius:8px;
            }
          }
        }
      }
      .el-dialog__wrapper {
        .el-dialog {
          background: none;
          border: none;
          box-shadow: none;
          width: 325px;
          background:#FFFFFF;
          box-shadow:0px 1px 4px 0px rgba(0,0,0,0.09);
          border-radius:8px;
          .el-dialog__header {
            padding: 15px;
            height: 55px;
            box-sizing: border-box;
            background-color: #FBFBFB;
            border-radius:8px;
            .dialogTitle {
              display: flex;
              align-items: center;
              img {
                height: 25px;
                width: 25px;
                border-radius: 25px;
                border: 1px solid #E5E5E5;
                vertical-align: middle;
                margin-right: 10px;
              }
              p {
                font-size: 15px;
                line-height: 17px;
                font-weight: 600;
                height: 17px;
              }
            }
          }
          .el-dialog__body {
            padding: 0;
            border-radius:8px;
            .dialogContent {
              padding: 0 15px;
              margin-top: 25px;
              .dialogContent_voucher {
                height: 18px;
                font-weight: 600;
                line-height: 18px;
                font-size: 20px;
                text-align: center;
                color: #000000;
                margin-bottom: 35px;
              }
              div {
                height: 15px;
                line-height: 15px;
                font-size: 14px;
                margin-bottom: 20px;
                p:nth-child(1) {
                  float: left;
                  color: #8A8C92;
                }
                p:nth-child(2) {
                  float: right;
                  color: #000000;
                  font-weight: 500;
                }
              }
              .payment-id, .merchant-id {
                height: auto;
                display: flex;
                justify-content: space-between;
                line-height: 15px;
                p:nth-child(1) {
                  white-space: nowrap;
                }
                p:nth-child(2) {
                  text-align: right;
                }
              }
              .total_price {
                padding-bottom: 20px;
                border-bottom: 1px dashed #A7A9AE;
              }
            }
            .dialog-footer {
              background-color: #FBFBFB;
              margin-top: 5px;
              height: 46px;
              line-height: 46px;
              font-size: 13px;
              color: #D8D8D8;
              border-radius:8px;
              span {
                margin-right: 6px;
                margin-left: 53px;
              }
              img {
                vertical-align: middle;
                height: 12.87px;
                width: 48.9px;
              }
            }
            .footer {
              width: 100%;
              position: absolute;
              text-align: center;
              bottom: -116px;
              img {
                height: 56px;
                width: 56px;
                cursor: pointer;
              }
              .savePC {
                width: 100%;
                font-size: 15px;
                height: 15px;
                line-height: 15px;
                margin-top: 15px;
                color: #FFFFFF;
                text-align: center;
              }
            }
          }
        }
      }
      .bottom_msg_pc {
        height: 60px;
        line-height: 60px;
        text-align: center;
        background-color: #464646;
        color: #FFFFFF;
        span {
          margin-top: 22px;
          line-height: 16px;
          display: inline-block;
          height: 16px;
          margin-right: 8px;
          font-size: 14px;
        }
        img {
          width: 81px;
          height: 15px;
          vertical-align: middle;
        }
      }
      .bottom_msg_pc_fixed {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 60px;
        line-height: 60px;
        text-align: center;
        background-color: #464646;
        color: #FFFFFF;
        span {
          margin-top: 22px;
          line-height: 16px;
          display: inline-block;
          height: 16px;
          margin-right: 8px;
          font-size: 14px;
        }
        img {
          width: 81px;
          height: 15px;
          vertical-align: middle;
        }
      }
    }
    // 解决屏幕出现滚动条背景颜色不能铺满的情况
    .payment-result_resize {
      height: 100%
    }
    // 屏幕出现滚动条时，距离底部高度需要增加脱离文档流元素的高度(默认39px)
    .main_wraper_resize_fixed {
      margin-bottom: 99px !important;
    }
  }
</style>
